import React, { useEffect, useState } from 'react'
import { useTranslation } from "react-i18next"
import { Container, Button, Row, Form, Col, Card } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { editUserClient } from '../../../actions/profiles/usersActions'
import { getClient } from '../../../actions/profiles/clientsActions'
import Swal from 'sweetalert2'
import useAuth from '../../../context/auth/useAuth'
import HeadConfig from '../../../components/menus/SubMenuConfig'

export default function Socialdata({clientselected, usertype}) {
    const { t } = useTranslation()
	const {clientauth} = useAuth()
    const dispatch = useDispatch()

    const {user, resultuser} = useSelector(state=>state.users)
    const {client} = useSelector(state=>state.clients)

    const [isUpdating, setIslogging] = useState(false)
    const [formState, setFormState] = useState({})

    useEffect(() => {
        if(clientauth && clientselected){
            dispatch(getClient(clientselected))
        }
    },[dispatch, t, clientauth, clientselected])

    useEffect(() => {
        if(client){
            setFormState({
                x: client?.x,
                facebook: client?.facebook,
                instagram: client?.instagram,
                tiktok: client?.tiktok,
                twitch: client?.twitch,
                linkedin: client?.linkedin,
            })
        }
    // eslint-disable-next-line
    }, [user, client])

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()
        setIslogging(true)
        dispatch(editUserClient({...formState, clienttoupdate: clientselected}, null, null))
        setIslogging(false)
    }

    useEffect(() => {
        if(resultuser){
            let newresult = resultuser
            dispatch({
                type: 'USER_RESET_RESULT'
            })
            switch (newresult) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        icon: 'success',
                        text: t('users.useredited')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    return (
        <Container className='cuerpo'>
            <Row className="my-3">
                <Col>
                    <HeadConfig nuevaSeccion="social" type={clientauth?.client === clientselected || usertype === 'superadmin' ? 'client' : 'member'} usertype={usertype}/>
                </Col>
            </Row>
            <Row className="my-3">
                <Col>
                    <Card>
                        <Card.Body>
                            <h2>{t('users.editsocial')}</h2>
                            <hr className='mb-4'/>
                            <Form className="formulario" onSubmit={handleEdit}>
                                <Row className="my-3">
                                    <Col xs={12} lg={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Control
                                                className={formState.x ? 'has-content' : ''}
                                                type='text'
                                                name='x' 
                                                value={formState.x ||  ''}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Label htmlFor='x'>{t('users.x')}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Control
                                                className={formState.facebook ? 'has-content' : ''}
                                                type='text'
                                                name='facebook' 
                                                value={formState.facebook ||  ''}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Label htmlFor='facebook'>{t('users.facebook')}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col xs={12} lg={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Control
                                                className={formState.instagram ? 'has-content' : ''}
                                                type='text'
                                                name='instagram' 
                                                value={formState.instagram ||  ''}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Label htmlFor='instagram'>{t('users.instagram')}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Control
                                                className={formState.tiktok ? 'has-content' : ''}
                                                type='text'
                                                name='tiktok' 
                                                value={formState.tiktok ||  ''}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Label htmlFor='tiktok'>{t('users.tiktok')}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col xs={12} lg={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Control
                                                className={formState.twitch ? 'has-content' : ''}
                                                type='text'
                                                name='twitch' 
                                                value={formState.twitch ||  ''}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Label htmlFor='twitch'>{t('users.twitch')}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                    <Col xs={12} lg={6}>
                                        <Form.Group className='form-group'>
                                            <Form.Control
                                                className={formState.linkedin ? 'has-content' : ''}
                                                type='text'
                                                name='linkedin' 
                                                value={formState.linkedin ||  ''}
                                                onChange={handleInputChange}
                                            />
                                            <Form.Label htmlFor='linkedin'>{t('users.linkedin')}</Form.Label>
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row className="mt-5">
                                    <Col xs={12} lg={6} className='ms-auto'>
                                        <Button variant='primary' type="submit" className="w-100 my-2">
                                        {isUpdating
                                            ?
                                                <>
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </>
                                            :
                                                <>{t('global.update')}</>
                                        }
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    )
}
